import { render, staticRenderFns } from "./WorkingUnsolved.vue?vue&type=template&id=11f948d4"
import script from "./WorkingUnsolved.vue?vue&type=script&lang=js"
export * from "./WorkingUnsolved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f948d4')) {
      api.createRecord('11f948d4', component.options)
    } else {
      api.reload('11f948d4', component.options)
    }
    module.hot.accept("./WorkingUnsolved.vue?vue&type=template&id=11f948d4", function () {
      api.rerender('11f948d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingUnsolved.vue"
export default component.exports